module.exports = __webpack_public_path__ + "img/41.aed45e9e.jpg";